import moment from 'moment'

export const isAuthorized = (state) => state.token !== null

export const name = (state) => state.name

export const orgas = (state) => state.orgas

export const hasOrga = (state) => state.orgas && state.orgas.length > 0 || false

export const activeOrga = (state) => state.activeOrga

export const activeViewState = (state) => state.activeViewState

export const activeViewStates = (state) => state.activeViewStates

export const fisPersid = (state) => state.fisPersid

export const email = (state) => state.email

export const researcher = (state) => {
  return state.forscher
}

export const selectedOrga = (state) => {
  if (state.orgas != null && state.orgas.length > 0) {
    let orgasByID = state.orgas.filter(x => x._id === state.selectedOrgaID)
    if (orgasByID.length > 0) {
      return orgasByID[0]
    } else {
      return state.orgas[0]
    }
  } else {
    return null
  }
}

export const remainingSessionLength = (state, getters, rootState) => {
  if (state.token == null) {
    return 0
  } else {
    let sessionDestroyDate = parseInt(state.token.split(':')[1])
    let remainingSessionLength = moment(sessionDestroyDate).diff(rootState.now)
    return remainingSessionLength
  }
}

export const getUser = (state) => {
  return {
    name: state.name,
    organisationseinheiten: state.orgas,
    roles: state.roles
  }
}

export const roles = (state) => state.roles

export const token = (state) => state.token

export const isLoading = (state) => state.loading

export const getSavedViews = (state) => state.savedViews



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js